import Vue from 'vue';

import store from '@/store';

const global = {
	install(Vue) {
		Vue.prototype.$openOverlayModal = () =>
			store.dispatch('appStore/openOverlayModal');
		Vue.prototype.$closeOverlayModal = () =>
			store.dispatch('appStore/closeOverlayModal');

		Vue.prototype.$setOverlayModalTitle = payload =>
			store.dispatch('appStore/setOverlayModalTitle', payload);

		Vue.prototype.$setOverlayContentComp = payload =>
			store.dispatch('appStore/setOverlayContentComp', payload);
	},
};

Vue.use(global);
